import React from "react";

const CurrencyHelper = {
  GetCurrencySymbolHelper: (data) => {
    switch (data) {
      case "try":
        return " ₺";
      case "tl":
        return " ₺";
      case "usd":
        return " $";
      case "eur":
        return " €";
      case "aud":
        return " AU$";
      case "chf":
        return " CHF";
      case "cny":
        return " ¥";
      case "jpy":
        return " ¥";
      case "gbp":
        return " £";
      case "dkk":
        return " DKK";
      default:
        return "";
    }
  },
};


const FormatMoney = (amount, currencyCode, processType) => {
  amount = Math.round(amount * 100) / 100;

  if(processType === 2 && amount > 0) {
    amount = -1 * Math.abs(amount);
  }

  const base = amount.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (!currencyCode) return base;

  switch (currencyCode.toLowerCase()) {
    case "usd": return base + " $";
    case "try":
    case "tl":  return base + " ₺";
    case "eur": return base + " €";
    case "aud": return base + " AU$";
    case "chf": return base + " CHF";
    case "cny": return base + " ¥";
    case "jpy": return base + " ¥";
    case "gbp": return base + " £";
    case "dkk": return base + " DKK";
    default:    return base;
  }
}

export { CurrencyHelper, FormatMoney };
